import { selectOnboarding } from '../../selectors'

const DEFAULT_FORM_FIELDS = {
  firstLastNameInput: '',
  emailInput: '',
  passwordInput: '',
  companyInput: '',
  subdomainInput: '',
  termsCheckbox: false,
}

function selectBase(state) {
  return selectOnboarding(state).signup || {}
}

export function selectFormFields() {
  return DEFAULT_FORM_FIELDS
}

export function selectIsCreatingAccount(state) {
  return selectBase(state).isCreatingAccount || false
}

export function selectIsCheckingDomain(state) {
  return selectBase(state).isCheckingDomain || false
}

export function selectIsDomainValid(state) {
  return selectBase(state).isDomainValid
}

export function selectDomainErrorMessage(state) {
  return selectBase(state).domainErrorMessage || ''
}
